import { render } from "./EditableRangeSlider.vue?vue&type=template&id=c1045cb2&scoped=true"
import script from "./EditableRangeSlider.vue?vue&type=script&lang=js"
export * from "./EditableRangeSlider.vue?vue&type=script&lang=js"

import "./EditableRangeSlider.vue?vue&type=style&index=0&id=c1045cb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1045cb2"

export default script